import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { IngestionAnalysisActions } from '../../actions/generations/doc-analysis';
import { HttpBaseService } from 'src/app/base/http-base.service';
import { catchError, EMPTY, map, of, switchMap } from 'rxjs';
import { UtilService } from 'src/app/services/util.service';

@Injectable()
export class IngestionAnalysisEffects {
  private readonly actions$ = inject(Actions);
  private readonly httpService = inject(HttpBaseService);
  private readonly utilService = inject(UtilService);

  retryFailedIngestions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(IngestionAnalysisActions.retryFailedIngestions),
      switchMap((action: any) => {
        const { apiConstants, urlVariables } = action;
        return this.httpService[apiConstants.method](apiConstants, urlVariables).pipe(
          map((response: any) => {
            const isNull = response === null;
            if (isNull) {
              // Empty null interpreted as success scenario (no failed ingestions remaining)
              return IngestionAnalysisActions.retryFailedIngestionsSuccess();
            } else {
              throw new Error('Unexpected response format');
            }
          }),
          catchError((err) => {
            return of(IngestionAnalysisActions.retryFailedIngestionsFailure());
          })
        );
      })
    )
  );

  retryFailedIngestionsSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(IngestionAnalysisActions.retryFailedIngestionsSuccess),
        switchMap(() => {
          // Optionally notify success; extend with refresh logic if required
          return EMPTY;
        })
      ),
    { dispatch: false }
  );

  retryFailedIngestionsFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(IngestionAnalysisActions.retryFailedIngestionsFailure),
        switchMap(() => {
          this.utilService.showError('Failed to retry failed ingestions.');
          return EMPTY;
        })
      ),
    {
      dispatch: false
    }
  );
}
